import { HttpClient } from '@angular/common/http';

import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs/internal/Observable';
import {
  AcceptAuthorizationVerbiageRequestV1,
  AcceptAuthorizationVerbiageResponseV1,
  RetrieveAuthorizationVerbiageRequestV1,
  RetrieveAuthorizationVerbiageResponseV1,
} from '../models';
import { PaymentAuthorizationVerbiageService } from './payment-authorization-verbiage.service';

export class PaymentAuthorizationVerbiageGuestCheckoutService extends PaymentAuthorizationVerbiageService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  public retrieveAuthorizationVerbiageV1(
    tenantId: string,
    retrieveAuthorizationVerbiageRequestV1: RetrieveAuthorizationVerbiageRequestV1,
  ): Observable<RetrieveAuthorizationVerbiageResponseV1> {
    return this.httpClient.post<RetrieveAuthorizationVerbiageResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/hosted-payments/retrieve-verbiage`,
      retrieveAuthorizationVerbiageRequestV1,
    );
  }

  public acceptAuthorizationVerbiageV1(
    tenantId: string,
    acceptAuthorizationVerbiageRequestV1: AcceptAuthorizationVerbiageRequestV1,
  ): Observable<AcceptAuthorizationVerbiageResponseV1> {
    return this.httpClient.post<AcceptAuthorizationVerbiageResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/hosted-payments/accept-verbiage`,
      acceptAuthorizationVerbiageRequestV1,
    );
  }
}
